<template>
  <div class="jl-account-message-wrap">
    <div class="jl-acc-msg-box">
      <div v-loading="isloading" class="jl-loading-box">
        <div class="jl-com-nodata-tips" v-if="nodata">
          <div class="jl-com-nodata-box">
            <i class="jl-icon-wushuju"></i>
            <p class="text">暂无数据</p>
          </div>
        </div>
        <ul class="msg-list">
          <li class="item" v-for="item in list" :key="item.id">
            <div :class="[item.isNewRecord?'item-box active':'item-box']">
              <div class="item-img"></div>
              <div class="item-info">
                <p class="text1">
                  <span class="alt-span-1">系统</span>
                  <span>{{item.createDate}}</span>
                </p>
                <p class="text2">{{item.content}}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="jl-page-box clearfix" v-if="list.length > 0">
        <div style="float: right">
          <v-pagination
            :total="total"
            :display="display"
            :currentPage="current"
            @pagechange="pagechange"
          ></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getMesgList } from "@/api/user";
import Pagination from "../../../components/Pagination";
export default {
  name: "accountMessageList",
  components: {
    "v-pagination": Pagination
  },
  data() {
    return {
      list: [],
      userId: "",
      total: 0,
      display: 10,
      current: 1,
      isloading: true,
      nodata: false
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.userId = this.userInfo.userId;
    getMesgList(this);
  },
  methods: {
    pagechange(idx) {
      //console.log(idx);
      this.current = idx;
      getMesgList(this);
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-acc-msg-box {
  padding: 0 50px;
  background: #fff;
  min-height: 450px;
}
.msg-list {
  .item {
    padding: 34px 0 38px 0;
    border-bottom: 1px dashed #e0e0e0;
    .item-box {
      position: relative;
      padding-left: 75px;
      &.active::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background: #e50011;
      }
    }
    .item-img {
      position: absolute;
      left: 0;
      top: 0;
      width: 48px;
      height: 48px;
      border-radius: 24px;
      background: url("../../../assets/img/zkj-msg-logo.png") no-repeat center
        center;
      border: 1px solid #e0e0e0;
    }
    .item-info {
      .text1 {
        font-size: 14px;
        color: #999;
        padding-bottom: 8px;
        .alt-span-1 {
          margin-right: 15px;
        }
      }
      .text2 {
        font-size: 16px;
        color: #666;
        padding-top: 8px;
      }
    }
  }
}
.jl-page-box {
  margin-top: 30px;
}
</style>

